import {isEmpty} from 'lodash';

import {
  CirclePermissionsModel,
  ContactPermissionAccessEnum,
  ContactPermissionModel,
} from '../../../src/models/api/circlePermissionModel';

export function hasAnySharedContactsAccess(contactPermission: ContactPermissionModel) {
  return (
    contactPermission.access === ContactPermissionAccessEnum.ALL ||
    contactPermission.access === ContactPermissionAccessEnum.CARD_GROUPS
  );
}

export function hasFullSharedContactsAccess(contactPermission: ContactPermissionModel) {
  return contactPermission.access === ContactPermissionAccessEnum.ALL;
}

export const MAX_CARD_GROUP_PERMISSIONS = 5;

export function areCirclePermissionsInvalid(permissions: CirclePermissionsModel) {
  const contactPermission = permissions.contacts;

  if (!contactPermission || contactPermission.access !== ContactPermissionAccessEnum.CARD_GROUPS) {
    return false;
  }

  const {cardGroupIds} = contactPermission;
  return isEmpty(cardGroupIds) || cardGroupIds.length > MAX_CARD_GROUP_PERMISSIONS;
}
